import { Component } from '@verndale/core';
import { nanoid } from 'nanoid';

import { isIE } from '../utils/browsers';

class HeadingMedia extends Component {
  setupDefaults() {
    this.dom = {
      $image: this.el._$('img.heading-media__media'),
      $mediaWrapper: this.el._$('.heading-media__media-wrapper')
    };

    this.playButtonLabel = this.el.dataset.playButtonLabel;
    this.videoId = this.el.dataset.videoId;
    this.videoTitle = this.el.dataset.videoTitle;
    this.containerId = `video-${nanoid()}`;
    this.checkImage();
    this.addVideoPlayer();
  }

  addListeners() {
    const { $mediaWrapper } = this.dom;

    $mediaWrapper._on('click', ::this.handleClick);
  }

  handleClick(e) {
    const $button = e.target.closest('.heading-media__play-button');

    if ($button) {
      this.removeButton($button);
      this.removeImage();
      this.el.dataset.hideGradient = 'true';
    }
  }

  checkImage() {
    const { $image } = this.dom;

    if (!$image) {
      this.el.classList.add('nopseudo');
    }
  }

  removeButton($button) {
    if ($button) {
      const { youtubeVideo, $mediaWrapper } = this.dom;
      const $iframe = $mediaWrapper._$('iframe');
      $iframe.removeAttribute('tabindex');

      if (isIE) {
        $iframe.src = `${$iframe.src}?autoplay=1&rel=0`;
      } else {
        youtubeVideo?.play();
      }

      $iframe.focus();
      $button.parentNode.removeChild($button);
    }
  }

  removeImage() {
    const { $image } = this.dom;

    if ($image) {
      $image.parentNode.removeChild($image);
    }
  }

  addVideoPlayer() {
    const { $mediaWrapper, $image } = this.dom;

    $mediaWrapper.insertAdjacentHTML('afterbegin', this.getIframe());
    if ($image) {
      $mediaWrapper.insertAdjacentHTML('beforeend', this.getPlayButton());
    }

    if (!isIE) {
      import('yt-player').then((module) => {
        const YTPlayer = module.default;
        const element = this.el._$(`.${this.containerId}`);

        this.dom.youtubeVideo = new YTPlayer(element, {
          related: false,
          modestBranding: true,
          host: '//youtube.com'
        });
        this.dom.youtubeVideo.load(this.videoId);
      });
    }
  }

  getIframe() {
    return isIE
      ? `
      <div class="heading-media__media" tabindex="-1">
        <iframe
          loading="lazy"
          src="https://www.youtube.com/embed/${this.videoId}"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen="allowfullscreen"
          msallowfullscreen="msallowfullscreen"
          webkitallowfullscreen="webkitallowfullscreen"
          title="${this.videoTitle}"
          tabindex="-1"
        ></iframe>
      </div>
    `
      : `
      <div class="heading-media__media" tabindex="-1">
        <div class="${this.containerId}" tabindex="-1"></div>
      </div>
    `;
  }

  getPlayButton() {
    return `
      <button class="heading-media__play-button" aria-label="${this.playButtonLabel}">
        <svg aria-hidden="true">
          <use xlink:href="#play-outline" />
        </svg>
      </button>
    `;
  }
}

export default HeadingMedia;
